var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/Common/UI/DndOverNodeContent.tsx";
import { TargetNodeContent, OverNodeTopBorder, OverNodeBottomBorder } from "./DndOverNodeContent.styled";
import { jsx as _jsx } from "react/jsx-runtime";
export var DndOverNodeContent = function DndOverNodeContent(_ref) {
  var isDragging = _ref.isDragging,
      isMiddleOver = _ref.isMiddleOver,
      isTopOver = _ref.isTopOver,
      isBottomOver = _ref.isBottomOver,
      canDrop = _ref.canDrop,
      overContent = _ref.overContent,
      someoneDragging = _ref.someoneDragging,
      _ref$deepness = _ref.deepness,
      deepness = _ref$deepness === void 0 ? 0 : _ref$deepness,
      canDropOrdering = _ref.canDropOrdering;
  var isAnyOver = isTopOver || isBottomOver || isMiddleOver;
  var levelOffset = 18;
  var lastLevelOffset = 10;

  if (isTopOver) {
    return /*#__PURE__*/_jsx(OverNodeTopBorder, {
      xDiff: (deepness + 1) * levelOffset + lastLevelOffset,
      canDrop: !!canDropOrdering
    });
  }

  if (isBottomOver) {
    return /*#__PURE__*/_jsx(OverNodeBottomBorder, {
      xDiff: (deepness + 1) * levelOffset + lastLevelOffset,
      canDrop: !!canDropOrdering
    });
  }

  if (isDragging && !isAnyOver) {
    return /*#__PURE__*/_jsx(TargetNodeContent, {
      backgroundImage: "data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='6' ry='6' stroke='%23353B604D' stroke-width='1' stroke-dasharray='5%2c4%2c5%2c4' stroke-dashoffset='7' stroke-linecap='round'/%3e%3c/svg%3e"
    });
  }

  if (someoneDragging && isAnyOver && !canDrop) {
    return /*#__PURE__*/_jsx(TargetNodeContent, {
      background: 'rgba(217, 87, 94, 0.1)'
    });
  }

  if (isMiddleOver) {
    return overContent || null;
  }

  return null;
};